let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bguy3")).then(() => parcelRequire('cppNo'));